import {
  assessmentConstants
} from '../_constants';

export function assessment(state = {}, action) {
  // console.log('state',state,action)
  switch (action.type) {


    case assessmentConstants.USER_ASSESSMENT_USER_PROFILE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.USER_ASSESSMENT_USER_PROFILE_SUCCESS:
      return {
        ...state,
        userAssessmentUserProfileData: action.assessment.userAssessmentUserProfileData,

      };
    case assessmentConstants.USER_ASSESSMENT_USER_PROFILE_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case assessmentConstants.GET_ASSESSMENT_PACKAGE_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.GET_ASSESSMENT_PACKAGE_LIST_SUCCESS:
      return {
        ...state,
        getAssessmentPackagesListData: action.assessment.getAssessmentPackagesListData,

      };
    case assessmentConstants.GET_ASSESSMENT_PACKAGE_LIST_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case assessmentConstants.USER_ASSESSMENT_PACKAGE_BUY_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.USER_ASSESSMENT_PACKAGE_BUY_SUCCESS:
      return {
        ...state,
        userAssessmentPackageBuyData: action.assessment.userAssessmentPackageBuyData,

      };
    case assessmentConstants.USER_ASSESSMENT_PACKAGE_BUY_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case assessmentConstants.USER_ASSESSMENT_PACKAGE_ORDERS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.USER_ASSESSMENT_PACKAGE_ORDERS_SUCCESS:
      return {
        ...state,
        userAssessmentOrdersData: action.assessment.userAssessmentOrdersData,

      };
    case assessmentConstants.USER_ASSESSMENT_PACKAGE_ORDERS_FAILURE:
      return {
        ...state,
        error: action.error
      };




    case assessmentConstants.USER_ASSESSMENT_SURVEY_LOGIN_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.USER_ASSESSMENT_SURVEY_LOGIN_SUCCESS:
      return {
        ...state,
        userAssessmentSurveyLoginData: action.assessment.userAssessmentSurveyLoginData,

      };
    case assessmentConstants.USER_ASSESSMENT_SURVEY_LOGIN_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case assessmentConstants.USER_ASSESSMENT_SURVEY_LOGIN_BY_OTP_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.USER_ASSESSMENT_SURVEY_LOGIN_BY_OTP_SUCCESS:
      return {
        ...state,
        userAssessmentSurveyLoginByOTPData: action.assessment.userAssessmentSurveyLoginByOTPData,

      };
    case assessmentConstants.USER_ASSESSMENT_SURVEY_LOGIN_BY_OTP_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case assessmentConstants.GET_ORDER_BOOK_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.GET_ORDER_BOOK_LIST_SUCCESS:
      return {
        ...state,
        getOrderBookListData: action.assessment.getOrderBookListData,

      };
    case assessmentConstants.GET_ORDER_BOOK_LIST_FAILURE:
      return {
        ...state,
        error: action.error
      };


    case assessmentConstants.USER_ASSESSMENT_RESPONSE_ANALYTICS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.USER_ASSESSMENT_RESPONSE_ANALYTICS_SUCCESS:
      return {
        ...state,
        userAssessmentResponseAnalyticsData: action.assessment.userAssessmentResponseAnalyticsData,

      };
    case assessmentConstants.USER_ASSESSMENT_RESPONSE_ANALYTICS_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case assessmentConstants.USER_ASSESSMENT_ORDER_NAME_UPDATE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.USER_ASSESSMENT_ORDER_NAME_UPDATE_SUCCESS:
      return {
        ...state,
        userAssessmentOrderNameUpdateData: action.assessment.userAssessmentOrderNameUpdateData,

      };
    case assessmentConstants.USER_ASSESSMENT_ORDER_NAME_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case assessmentConstants.GET_ASSESSMENT_PACKAGE_BY_ID_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.GET_ASSESSMENT_PACKAGE_BY_ID_SUCCESS:
      return {
        ...state,
        getAssessmentPackagesByIdData: action.assessment.getAssessmentPackagesByIdData,

      };
    case assessmentConstants.GET_ASSESSMENT_PACKAGE_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error
      };


    case assessmentConstants.GET_ASSESSMENT_CART_ITEMS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.GET_ASSESSMENT_CART_ITEMS_SUCCESS:
      return {
        ...state,
        getAssessmentCartItemsData: action.assessment.getAssessmentCartItemsData,

      };
    case assessmentConstants.GET_ASSESSMENT_CART_ITEMS_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case assessmentConstants.GET_ASSESSMENT_CART_COUNT_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.GET_ASSESSMENT_CART_COUNT_SUCCESS:
      return {
        ...state,
        getAssessmentCartCountData: action.assessment.getAssessmentCartCountData,

      };
    case assessmentConstants.GET_ASSESSMENT_CART_COUNT_FAILURE:
      return {
        ...state,
        error: action.error
      };



    case assessmentConstants.GET_ASSESSMENT_CART_PRICE_TOTAL_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.GET_ASSESSMENT_CART_PRICE_TOTAL_SUCCESS:
      return {
        ...state,
        getAssessmentCartPriceTotalData: action.assessment.getAssessmentCartPriceTotalData,

      };
    case assessmentConstants.GET_ASSESSMENT_CART_PRICE_TOTAL_FAILURE:
      return {
        ...state,
        error: action.error
      };


    case assessmentConstants.SAVE_ASSESSMENT_CONTACT_US_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.SAVE_ASSESSMENT_CONTACT_US_SUCCESS:
      return {
        ...state,
        saveAssessmentContactUsData: action.assessment.saveAssessmentContactUsData,

      };
    case assessmentConstants.SAVE_ASSESSMENT_CONTACT_US_FAILURE:
      return {
        ...state,
        error: action.error
      };




    case assessmentConstants.UPDATE_ASSESSMENT_USER_PROFILE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.UPDATE_ASSESSMENT_USER_PROFILE_SUCCESS:
      return {
        ...state,
        updateAssessmentUserProfileData: action.assessment.updateAssessmentUserProfileData,

      };
    case assessmentConstants.UPDATE_ASSESSMENT_USER_PROFILE_FAILURE:
      return {
        ...state,
        error: action.error
      };




    case assessmentConstants.ASSESSMENT_DOWNLOAD_STATUS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.ASSESSMENT_DOWNLOAD_STATUS_SUCCESS:
      return {
        ...state,
        assessmentDownloadStatusData: action.assessment.assessmentDownloadStatusData,

      };
    case assessmentConstants.ASSESSMENT_DOWNLOAD_STATUS_FAILURE:
      return {
        ...state,
        error: action.error
      };




    case assessmentConstants.ASSESSMENT_DOWNLOAD_SHORT_PRODUCT_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.ASSESSMENT_DOWNLOAD_SHORT_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        getAssessmentPackagesShortListData: action.assessment.getAssessmentPackagesShortListData,

      };
    case assessmentConstants.ASSESSMENT_DOWNLOAD_SHORT_PRODUCT_LIST_FAILURE:
      return {
        ...state,
        error: action.error
      };






    case assessmentConstants.GET_USER_ASSESSMENT_LANG_REQUEST:
      return {
        ...state,
        loading: true
      };
    case assessmentConstants.GET_USER_ASSESSMENT_LANG_SUCCESS:
      return {
        ...state,
        getUserAssessmentLangReportData: action.assessment.getUserAssessmentLangReportData,

      };
    case assessmentConstants.GET_USER_ASSESSMENT_LANG_FAILURE:
      return {
        ...state,
        error: action.error
      };





    default:
      return state
  }
}